const translations = {
  PaymentSucceed: 'Płatność zakończona sukcesem',
  PaymentSucceedDescription:
    'Płatność zakończyła się sukcesem. Faktura została wysłana do KSeF i do godziny czasu będzie dostępna w zakładce "Faktury"',
  PaymentFailed: 'Płatność nie powiodła się',
  PaymentFailedDescription:
    'Płatność zakończyła się niepowodzeniem. Nie uzyskała autoryzacji lub brak wystarczających środków na koncie',
  PaymentPending: 'Płatność przyjęta',
  PaymentPendingDescription:
    'Płatność została przyjęta. Saldo i faktura pojawią się za chwilę.',
};

export default translations;
